// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
// 引入 我们准备好的 store
import store from '@/store/index.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
import  "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
import './theme-premium.css';
Vue.use(Vant);

// 全局注册
Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.config.productionTip = false

// 记录各页离开时的滚动位置，用于返回 keep-alive 页面时还原（避免每次回首页都弹回顶部）
var pageScrollMap = {};
router.afterEach((to, from, next) => {
  var keep = to.matched.some(function (r) {
    return r.meta && r.meta.keepAlive;
  });
  if (keep && pageScrollMap[to.fullPath] != null) {
    // keep-alive 页面 DOM 已缓存，等重新插入后还原滚动位置
    var y = pageScrollMap[to.fullPath];
    Vue.nextTick(function () {
      requestAnimationFrame(function () {
        window.scrollTo(0, y);
      });
    });
  } else {
    window.scrollTo(0, 0); //新页面/首次进入 keep-alive 页面：回到顶部
    if (document.querySelector('.index-page')) {
      document.querySelector('.index-page').scrollTo(0, 0);
    }
  }
});
router.beforeEach((to, from, next) => {
  // 离开当前页前保存其滚动位置
  pageScrollMap[from.fullPath] = window.scrollY || document.documentElement.scrollTop || 0;
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (sessionStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/login', // 未登录则跳转至login页面
        query: { redirect: to.fullPath } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }


});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js